import compose from 'react-hooks-compose'

import { useAcceptCookiesLogic } from './useAcceptCookies'
import { AcceptCookiesPresenter } from './presenter'

export const AcceptCookies = compose(props => ({
	useLogic: () => useAcceptCookiesLogic(props),
}))(AcceptCookiesPresenter)
